import { useEffect, useRef, useState } from "react";

function FadeInOnScroll({ children, delay = 0, threshold = 0.2 }) {
    const ref = useRef();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => setVisible(entry.isIntersecting),
            { threshold }
        );
        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, [threshold]);

    return (
        <div
            ref={ref}
            style={{
                opacity: visible ? 1 : 0,
                transform: visible ? "translateY(0)" : "translateY(20px)",
                transition: `all 0.8s ease-out ${delay}s`,
            }}
        >
            {children}
        </div>
    );
}

export default FadeInOnScroll;